import React from "react";
import "react-toggle/style.css"
import 'react-input-checkbox/lib/react-input-checkbox.min.css';
import Select from 'react-select'
import { Card, ListGroup, OverlayTrigger, Alert } from 'react-bootstrap'
import { connect } from "react-redux";
import { renderCoverageTooltip } from "../../components/CoverageDescriptions";
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { FULL_QUOTE_STEPS, COMPONENTS, slectColourStyles } from "../../AppConstants";
import { ICoverageConfig, IListOption, ICoverage, IQuoteApiClient, ILOBApiClient, IPaths } from "../../classes/Domain";
import QuoteStepBase from '../../components/QuoteStepBase'
import Utilities from "../../classes/Utilities";
import * as _ from 'lodash';
import SwipeableViews from 'react-swipeable-views';
import QuoteActions from "../../state/appActions";
import { IAppState } from "../../state/interfaces";
import FullQuoteActions from "../../state/fullQuoteActions";
import { IUpdateCoveragesResult, ICoverages, IMvrResult } from "../../classes/ExternalQuote";
import ReactLoading from 'react-loading';

const rejectOption = { value: "REJECT", label: "I Reject" };

interface IAppStateUpdate {
    quoteId: number,
    paymentPlanCode: number,
    coverageConfig: ICoverages;
}

interface IState extends IQuoteStepState {
    updateResult: IUpdateCoveragesResult | null,
    mvrResult: IMvrResult | null,
    coverageConfigs: Array<ICoverageConfig>,
    selectedLimit: IListOption | null,
    loadingConfigs: boolean;
}

export interface IProps extends IQuoteStepComponentProps {
    quoteId: number,
    paymentPlanCode: number,
    reRated: boolean,
    vehiclesChanged: boolean,
    driversChanged: boolean,
    coverageConfigs: ICoverageConfig,
    externalCoverageConfigs: ICoverageConfig,
    isNonOwners: boolean,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths,
    reRateQuote: (quoteId: number, paymentPlanCode: number) => Promise<any>,
    reloadQuotePaymentInfo: (quoteId: number, quoteRerated: boolean) => Promise<any>,
    updateAppStateViolations: (quoteId: number) => Promise<any>;
}

interface ICoverageMap {
    coverageConfigCode: string,
    code: string,
    name: string,
    canBeDeclined: boolean,
    Ineligible: boolean,
    limits: Array<IListOption>
}

class Coverage extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.getSelectedLimit = this.getSelectedLimit.bind(this);
        this.onLimitChange = this.onLimitChange.bind(this);
        this.rejectCorrelationCoverage = this.rejectCorrelationCoverage.bind(this);
        this.selectCorrelationCoverage = this.selectCorrelationCoverage.bind(this);

        this.state = {
            loadingConfigs: false,
            coverageConfigs: [],
            updatingStore: false,
            selectedLimit: null,
            updateResult: null,
            mvrResult: null,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        if (this.props.externalCoverageConfigs) {
            this.setState({ ...this.state, loadingConfigs: false, coverageConfigs: [this.props.externalCoverageConfigs] });
        }
        else
        {
            const coveragesApiClient = this.props.lobApiClient;
            this.setState({ loadingConfigs: true }, () => {
                coveragesApiClient
                    .getCoverages(this.props.quoteId, this.props.coverageConfigs)
                    .then((response) => {
                        this.setState({ ...this.state, loadingConfigs: false, coverageConfigs: [response.data] });
                    });
            });
        }
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            this.props.updateAppState({
                quoteId: this.props.quoteId,
                paymentPlanCode: this.props.paymentPlanCode,
                coverageConfig: this.state.coverageConfigs[0]
            })
            .then((response) => {
                this.setState({ updateResult: response.data }, () => {
                    if (!this.state.updateResult?.isSuccess) {
                        this.setState({ ...this.state, updatingStore: false, errors: null });
                    }
                    else {
                        this.props.updateAppStateViolations(this.props.quoteId)
                            .then((mvrResponse) => {
                                this.setState({ mvrResult: mvrResponse.data }, () => {
                                    if (!this.state.mvrResult?.isSuccess) {
                                        this.setState({ ...this.state, updatingStore: false, errors: null });
                                    }
                                    else {
                                        if (this.state.mvrResult?.hasAdditionalDrivers && !this.props.isNonOwners) {
                                            this.setState({ ...this.state, updatingStore: false }, () => { this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_ADDITIONAL_DRIVERS, "")) });
                                        }
                                        else if (this.state.mvrResult?.hasViolationData) {
                                            this.setState({ ...this.state, updatingStore: false }, () => { this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_VIOLATIONS, "")) });
                                        }
                                        else if (this.state.updateResult?.isRerated || this.state.mvrResult?.isRerated || this.props.reRated || this.props.vehiclesChanged || this.props.driversChanged) {
                                            this.props.reloadQuotePaymentInfo(this.props.quoteId, true)
                                                .then(() => {
                                                    if (this.props.driversChanged) {
                                                        this.props.reRateQuote(this.props.quoteId, this.props.paymentPlanCode)
                                                            .then(() => {
                                                                this.setState({ ...this.state, updatingStore: false }, () => { this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS) });
                                                            });
                                                    }
                                                    else {
                                                        this.setState({ ...this.state, updatingStore: false }, () => { this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS) });
                                                    }
                                                }, () => this.setState({ ...this.state, updatingStore: false }));
                                        }
                                        else {
                                            this.setState({ ...this.state, updatingStore: false }, () => { this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS) });
                                        }
                                    }
                                })
                        }, () => this.setState({ ...this.state, updatingStore: false }));
                    }
                });
            },
            () => this.setState({ ...this.state, updatingStore: false }));
        });
    }

    mapCoverages(coverageConfigCode: string, coverages: Array<ICoverage>): Array<ICoverageMap> {
        const coverageGroups = _.groupBy(coverages, "code");
        return _.map(coverageGroups, (group, coverageCode) => {
            return {
                coverageConfigCode,
                code: coverageCode,
                name: group[0].name,
                canBeDeclined: !!_.find(group, (c) => c.canBeDeclined),
                Ineligible: !!_.find(group, (c) => c.Ineligible),
                limits: _.map(_.sortBy(group, ["order"]), (c) => ({ label: c.limit, value: c.value }))
            };
        });
    }

    findCoveragesIn(config: ICoverageConfig, coverageCode: string, vehicleId: number | null = null): Array<ICoverage> {
        if (null == vehicleId)
        {
            const policyCoverages = _.filter(config.liabilityCoverages, (cov) => cov.code === coverageCode);
            if (policyCoverages && policyCoverages.length > 0)
            {
                return policyCoverages;
            }

            const addonCoverages = _.filter(config.addonCoverages, (cov) => cov.code === coverageCode);
            if (addonCoverages && addonCoverages.length > 0)
            {
                return addonCoverages;
            }

            return [];
        }

        const vehicleCoverages = _.find(config.vehicleCoverages, (vcov) => vcov.vehicleId === vehicleId);
        if (!vehicleCoverages) return [];
        return _.filter(vehicleCoverages.coverages, (cov) => cov.code === coverageCode);
    }

    getSelectedLimit(coverageConfigCode: string, coverageCode: string, vehicleId: number | null = null): IListOption | null {
        const coverageConfig = _.find(this.state.coverageConfigs, (config) => config.code === coverageConfigCode);
        if (!coverageConfig) return null;

        const coverage = _.find(this.findCoveragesIn(coverageConfig, coverageCode, vehicleId), (cov) => cov.isSelected);
        return !coverage ? null : { label: coverage.limit, value: coverage.value };
    }

    getFirstLimit(coverageConfigCode: string, coverageCode: string, vehicleId: number | null = null): IListOption | null {
        const coverageConfig = _.find(this.state.coverageConfigs, (config) => config.code === coverageConfigCode);
        if (!coverageConfig) return null;

        const coverage = _.find(this.findCoveragesIn(coverageConfig, coverageCode, vehicleId), (cov) => cov.order == 0);
        return !coverage ? null : { label: coverage.limit, value: coverage.value };
    }

    selectCorrelationCoverage(coverageConfig: ICoverageConfig, coverageCode: string, vehicleId: number | null = null, limit: IListOption | null = null) {
        const coverages = this.findCoveragesIn(coverageConfig, coverageCode, vehicleId);
        const cov = limit
            ? _.find(coverages, (cov) => cov.value === limit.value)
            : _.find(coverages, (cov) => cov.value !== rejectOption.value);

        for (var i = 0; i < coverages.length; i++) {
            coverages[i].isSelected = false;
        }

        if (cov) {
            cov.isSelected = true;
        }
    }

    rejectCorrelationCoverage(coverageConfig: ICoverageConfig, coverageCode: string, vehicleId: number | null = null) {
        const coverages = this.findCoveragesIn(coverageConfig, coverageCode, vehicleId);
        const cov = _.find(coverages, (cov) => cov.value === rejectOption.value);

        for (var i = 0; i < coverages.length; i++) {
            coverages[i].isSelected = false;
        }

        if (cov) {
            cov.isSelected = true;
        }
    }

    onLimitChange(limit: IListOption | null, coverageConfigCode: string, coverageCode: string, vehicleId: number | null = null) {
        const { coverageConfigs } = { ...this.state };

        const coverageConfig = _.find(this.state.coverageConfigs, (config) => config.code === coverageConfigCode);
        if (!coverageConfig) return;

        const coverages = this.findCoveragesIn(coverageConfig, coverageCode, vehicleId);

        for (var i = 0; i < coverages.length; i++) {
            coverages[i].isSelected = false;

            if (limit && limit.value === rejectOption.value) {
                switch (coverages[i].code) {
                    case "UMBI":
                        {
                            this.rejectCorrelationCoverage(coverageConfig, "UMPD", vehicleId);
                            break;
                        }
                    case "COMP":
                        {
                            this.rejectCorrelationCoverage(coverageConfig, "COLL", vehicleId);
                            this.rejectCorrelationCoverage(coverageConfig, "RREIM", vehicleId);
                            //this.rejectCorrelationCoverage(coverageConfig, "TL", vehicleId);
                            break;
                        }
                    case "COLL":
                        {
                            this.rejectCorrelationCoverage(coverageConfig, "COMP", vehicleId);
                            this.rejectCorrelationCoverage(coverageConfig, "RREIM", vehicleId);
                            //this.rejectCorrelationCoverage(coverageConfig, "TL", vehicleId);
                            break;
                        }
                }
            }
        }

        if (limit && limit.value !== rejectOption.value) {
            const coverage = _.find(coverages, (cov) => cov.value === limit?.value);

            if (coverage) {
                switch (coverage.code) {
                    case "UMBI":
                        {
                            let biLimit = this.getSelectedLimit(coverageConfig.code, "BI", null);

                            if (biLimit) {
                                let _umLimit = limit.value.split("/")[0];
                                let _biLimit = biLimit.value.split("/")[0];

                                if (_umLimit && _biLimit && Number(_biLimit) < Number(_umLimit)) {
                                    this.selectCorrelationCoverage(coverageConfig, "BI", vehicleId, limit);
                                }
                            }

                            break;
                        }
                    case "BI":
                        {
                            let umLimit = this.getSelectedLimit(coverageConfig.code, "UMBI", null);

                            if (umLimit && umLimit.value !== rejectOption.value) {
                                let _biLimit = limit.value.split("/")[0];
                                let _umLimit = umLimit.value.split("/")[0];

                                if (_biLimit && _umLimit && Number(_umLimit) > Number(_biLimit)) {
                                    this.selectCorrelationCoverage(coverageConfig, "UMBI", vehicleId, limit);
                                }
                            }

                            break;
                        }
                    case "PIP":
                        {

                            this.selectCorrelationCoverage(coverageConfig, "MEDPM", vehicleId, rejectOption);
                            break;
                        }
                    case "MEDPM":
                        {
                            this.selectCorrelationCoverage(coverageConfig, "PIP", vehicleId, rejectOption);
                            break;
                        }
                    case "UMPD":
                        {
                            let umLimit = this.getSelectedLimit(coverageConfig.code, "UMBI", null);

                            this.selectCorrelationCoverage(coverageConfig, "UMBI", vehicleId, umLimit);
                            break;
                        }
                    //case "COMP":
                    //    {
                    //        this.selectCorrelationCoverage(coverageConfig, "COLL", vehicleId, limit);
                    //        break;
                    //    }
                    //case "COLL":
                    //    {
                    //        this.selectCorrelationCoverage(coverageConfig, "COMP", vehicleId, limit);
                    //        break;
                    //    }
                    case "TL":
                        {
                            for (var i = 0; i < coverageConfig.vehicleCoverages.length; i++) {
                                if (coverageConfig.vehicleCoverages[i].vehicleId != vehicleId) {
                                    this.selectCorrelationCoverage(coverageConfig, "TL", coverageConfig.vehicleCoverages[i].vehicleId, limit);
                                }

                                let compLimit = this.getSelectedLimit(coverageConfig.code, "COMP", coverageConfig.vehicleCoverages[i].vehicleId);

                                this.selectCorrelationCoverage(coverageConfig, "COMP", coverageConfig.vehicleCoverages[i].vehicleId, compLimit);
                                this.selectCorrelationCoverage(coverageConfig, "COLL", coverageConfig.vehicleCoverages[i].vehicleId, compLimit);
                            }
                            break;
                        }
                    case "RREIM":
                        {
                            for (var i = 0; i < coverageConfig.vehicleCoverages.length; i++)
                            {
                                if (coverageConfig.vehicleCoverages[i].vehicleId != vehicleId)
                                {
                                    this.selectCorrelationCoverage(coverageConfig, "RREIM", coverageConfig.vehicleCoverages[i].vehicleId, limit);
                                }

                                let compLimit = this.getSelectedLimit(coverageConfig.code, "COMP", coverageConfig.vehicleCoverages[i].vehicleId);
                                let collLimit = this.getSelectedLimit(coverageConfig.code, "COLL", coverageConfig.vehicleCoverages[i].vehicleId);

                                this.selectCorrelationCoverage(coverageConfig, "COMP", coverageConfig.vehicleCoverages[i].vehicleId, compLimit);
                                this.selectCorrelationCoverage(coverageConfig, "COLL", coverageConfig.vehicleCoverages[i].vehicleId, collLimit);
                            }
                            break;
                        }
                }

                coverage.isSelected = true;
            }
        }

        this.setState({ ...this.state, coverageConfigs });
    }

    renderCoverage(coverageMap: ICoverageMap, vehicleId: number | null = null) {
        return (1 === coverageMap.limits.length && !coverageMap.canBeDeclined) || coverageMap.Ineligible
            ?
            <ListGroup.Item key={Utilities.uniqueId()}>
                <label className="left-cell">
                    <span>
                        {coverageMap.name}&nbsp;
                        <OverlayTrigger
                            key={Utilities.uniqueId()}
                            trigger={["hover", "click"]}
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={(props) => renderCoverageTooltip(coverageMap.code, props, this.props.stateCode)}>
                            <i className="fas fa-info-circle"></i>
                        </OverlayTrigger>
                    </span>
                </label>
                <label className="right-cell">
                    {coverageMap.limits[0].label}
                </label>
            </ListGroup.Item>
            :
            <ListGroup.Item key={Utilities.uniqueId()}>
                <label className="left-cell">
                    <span>
                        {coverageMap.name}&nbsp;
                        <OverlayTrigger
                            key={Utilities.uniqueId()}
                            trigger={["hover", "click"]}
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={(props) => renderCoverageTooltip(coverageMap.code, props, this.props.stateCode)}>
                            <i className="fas fa-info-circle"></i>
                        </OverlayTrigger>
                    </span>
                </label>
                <label className="right-cell">
                    <Select
                        key={Utilities.uniqueId()}
                        options={coverageMap.canBeDeclined ? [rejectOption, ...coverageMap.limits] : coverageMap.limits}
                        value={coverageMap.canBeDeclined ? this.getSelectedLimit(coverageMap.coverageConfigCode, coverageMap.code, vehicleId) ?? rejectOption : this.getSelectedLimit(coverageMap.coverageConfigCode, coverageMap.code, vehicleId)}
                        onChange={(v) => this.onLimitChange(v ? { value: v["value"], label: v["label"] } : null, coverageMap.coverageConfigCode, coverageMap.code, vehicleId)}
                        isClearable={false}
                        styles={slectColourStyles} />
                </label>
            </ListGroup.Item>
    }

    render() {
        const coverageConfigSlides = this.state.coverageConfigs.map((config) =>
        <div>
            <div>
                <Card key={Utilities.uniqueId()} className="coverages-card">
                    <Card.Body key={Utilities.uniqueId()}>
                            <ListGroup variant="flush">
                            <ListGroup.Item key={Utilities.uniqueId()} variant="primary">Policy</ListGroup.Item>
                            {
                                this.mapCoverages(config.code, config.liabilityCoverages).map((coverageMap) => this.renderCoverage(coverageMap))
                            }
                            {!this.props.isNonOwners ? config.vehicleCoverages.map((vehicleCoverages) =>
                                <div key={Utilities.uniqueId()}>
                                    <ListGroup.Item key={Utilities.uniqueId()} variant="primary">{vehicleCoverages.vehicleDescription}</ListGroup.Item>
                                    {
                                        this.mapCoverages(config.code, vehicleCoverages.coverages).map((coverageMap) => this.renderCoverage(coverageMap, vehicleCoverages.vehicleId))
                                    }
                                </div>
                            ): null}
                            <ListGroup.Item key={Utilities.uniqueId()} variant="primary">Addons</ListGroup.Item>
                            {
                                this.mapCoverages(config.code, config.addonCoverages).map((coverageMap) => this.renderCoverage(coverageMap))
                            }
                        </ListGroup>
                    </Card.Body>
                </Card>
            </div>
            <div className="btnContainer">
                <ButtonContinue
                    label="Continue"
                    disabled={this.state.updatingStore}
                    showLoading={this.state.updatingStore}
                    onClick={() => this.next()} />
            </div>
        </div>
        );
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea">
                    <h5>Coverages Info</h5>
                </div>

                {this.state.loadingConfigs
                    ? <div className={"w-100 loading-indicator"}><ReactLoading type={"spin"} color={"#0096AE"} height={'40px'} width={'40px'} /></div>
                    : null
                }

                {
                    this.state.updateResult?.errors && this.state.updateResult.errors.length > 0
                        ? <Alert variant={"danger"}>
                            <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                            <p>Please review errors below</p>
                            <ul>
                                {
                                    this.state.updateResult.errors.map((error) => (
                                        <li key={Utilities.uniqueId()}>
                                            <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                                        </li>
                                    ))
                                }
                            </ul>
                        </Alert>
                        : null
                }

                {
                    this.state.mvrResult?.errors && this.state.mvrResult.errors.length > 0
                        ? <Alert variant={"danger"}>
                            <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                            <p>Please review errors below</p>
                            <ul>
                                {
                                    this.state.mvrResult.errors.map((error) => (
                                        <li key={Utilities.uniqueId()}>
                                            <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                                        </li>
                                    ))
                                }
                            </ul>
                        </Alert>
                        : null
                }

                {!this.state.loadingConfigs
                    ? <div className="quote-step coverages">
                        <SwipeableViews enableMouseEvents>
                            {coverageConfigSlides}
                        </SwipeableViews>
                    </div>
                    : null
                }
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    return {
        quoteUid: state.quoteUid,
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        coverageConfigs: state.coverageConfig,
        externalCoverageConfigs: state.externalQuote?.coverages,
        reRated: state.externalQuote?.reRated,
        vehiclesChanged: state.externalQuote?.vehicles?.some(x => x.changed) ?? false,
        driversChanged: state.externalQuote?.drivers?.some(x => x.driverChanged) ?? false,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode,
        isNonOwners: state.isNonOwners
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.COVERAGES)),
        updateAppState: (update: IAppStateUpdate) => dispatch(fullQuoteActions.updateCoverages(update.quoteId, update.paymentPlanCode, update.coverageConfig)),
        reloadQuotePaymentInfo: (quoteId: number, quoteRerated: boolean) => dispatch(fullQuoteActions.reloadQuotePaymentInfo(quoteId, quoteRerated)),
        reRateQuote: (quoteId: number, paymentPlanCode: number) => dispatch(fullQuoteActions.reRateQuote(quoteId, paymentPlanCode, false)),
        updateAppStateViolations: (quoteId: number) => dispatch(fullQuoteActions.getViolations(quoteId))
    };
}

export default connect(mapProps, mapDispatch)(Coverage);
